import { render, staticRenderFns } from "./topic-classification.vue?vue&type=template&id=409a9f4e"
import script from "./topic-classification.vue?vue&type=script&lang=js"
export * from "./topic-classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports